import R from 'ramda'
import { getIndentedJSONString } from 'pages/widgets/mapping/common-functions'

const SEND_DM_ACTION_TYPE = 'SEND_DM'
const SEND_DM_DISPLAY_TYPE = 'Send reply'

const isSendDmWidgetAction = R.propEq('type', SEND_DM_ACTION_TYPE)

const getMedia = R.pipe(
  R.prop('media'),
  R.cond([
    [Array.isArray, R.identity],
    [R.is(String), R.of]
  ])
)

const getQuickReplyOptions = R.path(['quickReply', 'options'])

const getQuickReply = R.pipe(getQuickReplyOptions, getIndentedJSONString)

const getCtas = R.pipe(R.prop('ctas'), getIndentedJSONString)

const convertSendDmWidgetActionToFormAction = R.applySpec({
  type: R.always(SEND_DM_DISPLAY_TYPE),
  action: R.always(SEND_DM_ACTION_TYPE),
  media: getMedia,
  quickReply: getQuickReply,
  ctas: getCtas,
  message: R.prop('message')
})

export { isSendDmWidgetAction, convertSendDmWidgetActionToFormAction }



// WEBPACK FOOTER //
// ./src/pages/widgets/mapping/actions/twitter/widget-to-form/send-dm.js